import { createFileRoute } from "@tanstack/react-router";
import ArtistsDashboard from "./-components/ArtistsDashboard";

export const Route = createFileRoute("/audiolab/roster/")({
  component: ArtistsDashboard,
  head: () => ({ meta: [{ title: "Roster | Audiolab | Lutely" }] }),
});
